
/* eslint-disable vue/no-mutating-props */
// `target` is the orchestrator's shared form-model object (state.client or a
// guest), intentionally passed by reference so each step can fill it in.
// The orchestrator owns the object; we mutate its fields in place by design.
import { mapGetters } from 'vuex'
import DobInput from '../parts/DobInput.vue'
import AddressFields from '../parts/AddressFields.vue'
import Location from '~/components/Location.vue'

export default {
    components: { DobInput, AddressFields, Location },
    props: {
        target: { type: Object, required: true },
        gate: { type: Boolean, default: false },
        isPrimary: { type: Boolean, default: true },
    },
    computed: {
        // `genders` ({ value: 'F'|'M', text }) is the Salesforce-synced store getter.
        ...mapGetters(['genders']),
        dobComplete () {
            return !!(this.target.dobM && this.target.dobD && String(this.target.dobY || '').length === 4)
        },
        // Location speaks { zip_code, fips, state, name }; mirror the target's
        // address fields into that shape so it can preselect the right county.
        locationValue () {
            return {
                zip_code: this.target.zip_code || '',
                fips: this.target.fips || '',
                state: this.target.state || '',
            }
        },
    },
    methods: {
        formatPhone (e) {
            const d = String(e.target.value || '').replace(/\D/g, '').slice(0, 10)
            let v = d
            if (d.length >= 4 && d.length < 7) v = `(${d.slice(0, 3)}) ${d.slice(3)}`
            else if (d.length >= 7) v = `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
            this.target.phone = v
        },
        // Location handles the ZIP→county lookup and multi-county selection,
        // then emits the resolved location; we mirror it back onto the target.
        onLocation (loc) {
            this.target.zip_code = (loc && loc.zip_code) || ''
            this.target.fips = (loc && loc.fips) || ''
            // #680 Phase 2a: the explicit state <select> above is the source
            // of truth once the user has picked from it — a ZIP/county
            // lookup firing afterward (e.g. they retype the ZIP) must not
            // silently overwrite that choice. Only backfill from the lookup
            // while the select is still empty (unset target, or a guest who
            // never touches the select at all).
            if (loc && loc.state && !this.target.state) this.$set(this.target, 'state', loc.state)
        },
        // #689: an autocomplete pick delivers the ZIP. Clear fips and let the
        // Location child re-derive the county from the new ZIP (its `value`
        // watcher runs the lookup and onLocation writes fips back), exactly as
        // if the ZIP had been typed. State was already set by AddressFields, so
        // onLocation's "only backfill while empty" rule leaves it alone.
        onAddressZip (zip) {
            this.target.zip_code = zip
            this.target.fips = ''
        },
    },
}
